import React, { useContext } from 'react';
import { ThemeContext } from '../../Context';
import { ThemeOptions } from '../../publicSession';
var ToolbarWrapper = function (_a) {
    var children = _a.children;
    var theme = useContext(ThemeContext);
    var themeClassName = "da-editor-theme-" + (theme === ThemeOptions.DARK ? 'dark' : 'bright');
    return (React.createElement("div", { className: themeClassName, "data-daeditor-retrieved-toolbar": true }, children));
};
ToolbarWrapper.displayName = 'ToolbarWrapper';
export default ToolbarWrapper;
//# sourceMappingURL=ToolbarWrapper.js.map